export function toast(msg, duration=1800){
  let el = document.createElement('div')
  el.style.position = 'fixed'
  el.style.left = '50%'
  el.style.bottom = '14%'
  el.style.transform = 'translateX(-50%)'
  el.style.background = 'rgba(0,0,0,0.75)'
  el.style.color = '#fff'
  el.style.padding = '10px 14px'
  el.style.borderRadius = '999px'
  el.style.zIndex = 9999
  el.style.fontSize = '14px'
  el.innerText = msg
  document.body.appendChild(el)
  setTimeout(()=> {
    el.style.transition = '0.3s'
    el.style.opacity = '0'
    setTimeout(()=> el.remove(), 300)
  }, duration)
}
